import { render, staticRenderFns } from "./ShiftUser.vue?vue&type=template&id=5c12957e"
import script from "./ShiftUser.vue?vue&type=script&lang=js"
export * from "./ShiftUser.vue?vue&type=script&lang=js"
import style0 from "./ShiftUser.vue?vue&type=style&index=0&id=5c12957e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports